import React, { useState, useEffect } from "react";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Alert } from "../../../components/ui/alert";
import { useSystemTheme } from "../hooks/useSystemTheme";
import "../../sales-forecast/styles/theme.css";

const AMENITY_OPTIONS = [
  "Basketball", "Clubhouse", "Gated", "Large Lots", "Pickleball",
  "Playground", "Pond", "Pool", "Prime Location", "Splash Pad",
  "Tennis", "Walking Trails",
];

export interface AmenityControlProps {
  selectedAmenities: string[];
  onChange: (selected: string[]) => void;
  clusterName: string;
  clusterDescription: string;
  serverSpecPct?: number | null;
  serverPresoldPct?: number | null;
}

export const AmenityControl: React.FC<AmenityControlProps> = ({
  selectedAmenities,
  onChange,
  clusterName,
  clusterDescription,
  serverSpecPct,
  serverPresoldPct,
}) => {
  const theme = useSystemTheme();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    setError("");
  }, [selectedAmenities]);

  const toggle = (opt: string) => {
    const next = selectedAmenities.includes(opt)
      ? selectedAmenities.filter((a) => a !== opt)
      : [...selectedAmenities, opt];
    setError("");
    onChange(next);
  };

  return (
    <div className={`amenity-control theme-${theme}`}>
      <div
        className="max-h-[45vh] overflow-y-auto p-3 rounded-lg"
        style={{
          backgroundColor: "var(--subcard-bg)",
          border: "1px solid var(--border-color)",
        }}
      >
        {/* <h3
          className="text-base font-semibold mb-3 text-center"
          style={{ color: "var(--text-color)" }}
        >
          Amenities
        </h3> */}

        {/* Two-column grid layout */}
        <div className="grid grid-cols-2 gap-x-4 gap-y-2">
          {AMENITY_OPTIONS.map((opt) => (
            <div
              key={opt}
              className="flex items-center space-x-2"
              style={{
                color: "var(--text-color)",
              }}
            >
              <Input
                id={`amenity-${opt}`}
                type="checkbox"
                checked={selectedAmenities.includes(opt)}
                onChange={() => toggle(opt)}
                style={{
                  accentColor: "var(--accent-color)",
                  cursor: "pointer",
                  width: "1rem",
                  height: "1rem",
                }}
              />
              <Label
                htmlFor={`amenity-${opt}`}
                style={{
                  color: "var(--text-color)",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                {opt}
              </Label>
            </div>
          ))}
        </div>
      </div>

      {error && (
        <Alert
          className="mt-2 rounded-md"
          style={{
            backgroundColor: "var(--error-bg)",
            color: "var(--error-text)",
            border: "1px solid var(--border-color)",
          }}
        >
          {error}
        </Alert>
      )}
    </div>
  );
};